/**********
 * Global *
 **********/
// Home
export const URL_HOME = '/'
